import Edit from './SSOCoporateGroupEdit'
import Main from './SSOCoporateGroupMain'
import New from './SSOCoporateGroupNew'
import Show from './SSOCoporateGroupShow'

const SSOCorporateGroup = {
  Edit,
  Main,
  New,
  Show,
}

export default SSOCorporateGroup
